import { render, staticRenderFns } from "./MigrateUser.vue?vue&type=template&id=4fe6c55e&"
import script from "./MigrateUser.vue?vue&type=script&lang=js&"
export * from "./MigrateUser.vue?vue&type=script&lang=js&"
import style0 from "./MigrateUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports